import { useQuery } from '@tanstack/react-query'

import { FinancialHierarchyNode } from 'components/financial/types'
import useAuth from 'hooks/useAuth'
import axiosServices from 'utils/axios'

const fetchAutoMapped = async (
  businessId: number | undefined,
  hierarchyId: number
): Promise<FinancialHierarchyNode[]> => {
  const response = await axiosServices.get(
    `/businesses/${businessId}/general_ledger_account_hierarchies/${hierarchyId}/auto_mapped_gl_accounts`,
    { params: { with_transaction_count: true } }
  )
  return response.data
}

export const useFetchAutoMapped = (hierarchyId: number) => {
  const { user } = useAuth()

  return useQuery({
    queryKey: ['fetch-auto-mapped', user?.business_id],
    queryFn: () => fetchAutoMapped(user?.business_id, hierarchyId),
    enabled: !!hierarchyId,
    staleTime: 0
  })
}
